import API from "@/common/API";
import GetCurrentUser, { parsedUser } from "@/common/GetCurrentUser";
import ActionBar from "@/components/core/ActionBar";
import { Routes } from "@/routes";
import { useEffect, useState } from "react";
import { Card, Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useHistory, useParams, useLocation } from "react-router-dom";

const AgentsPage = () => {
    const { t } = useTranslation();

    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    const [records, setRecords] = useState([]);
    const user = parsedUser();
    const bindData = async () => {
        try {
            setIsLoading(true);

            let request = await API.getAction("users/list?organizationId=" + user.OrganizationId);
            if (request.data.status === "ok") {
                // Process the response data as needed
                setRecords(request.data.response || []);
            }
        }
        catch (ex) {
            console.error(ex);
        }
        finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        bindData();
    }, []);

    return <Container className="py-4 ">
        <ActionBar
            title={t("Agents")}
            icon="fa fa-users me-2 "
            actions={
                <div className="btn-group">
                    {isLoading && <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>}
                </div>
            }
        ></ActionBar>
        {records.length > 0 &&
            < Card className="mt-4">
                <Card.Body className="p-0">
                    <table className="table table-hover mb-0">
                        <thead>
                            <tr>
                                <th>{t("Name")}</th>
                                {/* <th>{t("Email")}</th> */}
                                <th>{t("Role")}</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {records.map((agent: any) => (
                                <tr key={agent.id}>
                                    <td><b>{`${agent.firstName} ${agent.lastName}`}</b>
                                        <br />
                                        <small>{agent.email}</small>
                                    </td>
                                    <td>{agent.organizationRoleName}</td>
                                    <td className="text-end">
                                        <button className="btn btn-sm btn-primary" onClick={() => history.push(`${Routes.AgentDetails.clean}${agent.id}`)}>{t("View Details")}</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </Card.Body>
            </Card>}
    </Container >
};

export default AgentsPage;